const getters = {
  token: state => state.user.token,
  nickname: state => state.user.nickname,
  headimg: state => state.user.headimg,
  mobile: state => state.user.mobile,
  usertype:state=>state.user.usertype
}
export default getters
